const mergeIntervalsProblems = [
  {
      title: "Merge Intervals",
      url: "https://leetcode.com/problems/merge-intervals/"
    },
    {
      title: "Insert Interval",
      url: "https://leetcode.com/problems/insert-interval/"
    },
    {
      title: "Interval List Intersections",
      url: "https://leetcode.com/problems/interval-list-intersections/"
    },
    {
      title: "Non-overlapping Intervals",
      url: "https://leetcode.com/problems/non-overlapping-intervals/"
    },
    {
      title: "Minimum Number of Arrows to Burst Balloons",
      url: "https://leetcode.com/problems/minimum-number-of-arrows-to-burst-balloons/"
    }
];
export default mergeIntervalsProblems;